import { useEffect, useState } from "react";

const SortData = ({fieldName, sortNameData, sortTypeData, setSortDataFromChild}) => {
    const [sortType, setSortType] = useState('');
    const [sortField, setSortField] = useState(null);

    useEffect(() => {
        if(fieldName === sortNameData) {
            setSortType(sortTypeData);
            setSortField(sortNameData);
        } else {
            setSortType("");
            setSortField("");
        }
    }, [fieldName, sortNameData, sortTypeData]);

    const onSortChange = (e, type) => {
        var data = {
            "field" : fieldName,
            "type" : type
        }
        setSortField(fieldName);
        setSortType(type);
        setSortDataFromChild(data);
    }

    return (
        <>
            { sortType === '' ? <img onClick={(e) => onSortChange(e, 'asc')} className="cursor-pointer" src="../../../../assets/icons/table/sort-arrow-default.svg" alt="sort-arrow-default" /> : null }
            { sortType === 'asc' && sortField === fieldName ? <img onClick={(e) => onSortChange(e, 'desc')} className="cursor-pointer" src="../../../../assets/icons/table/sort-arrow-up.svg" alt="sort-arrow-up" /> : null }
            { sortType === 'desc' && sortField === fieldName ? <img onClick={(e) => onSortChange(e, '')} className="cursor-pointer" src="../../../../assets/icons/table/sort-arrow-down.svg" alt="sort-arrow-down" /> : null }
        </>
    )
}

export default SortData;